'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _d2 = require('d3');

var d3 = _interopRequireWildcard(_d2);

var _d3Tip = require('d3-tip');

var _d3Tip2 = _interopRequireDefault(_d3Tip);

var _d3SvgLegend = require('d3-svg-legend');

var _d3SvgLegend2 = _interopRequireDefault(_d3SvgLegend);

var _population = require('./population');

var _population2 = _interopRequireDefault(_population);

var _regionsLookup = require('./regionsLookup');

var _regionsLookup2 = _interopRequireDefault(_regionsLookup);

require('./bubble.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getTemporalParmeter = function getTemporalParmeter(temporal) {
  if (!temporal) {
    throw new Error('temporal is required');
  }
  var preparedTemporal = temporal;
  // temporal can be either: string (one year YYYY), string (year range YYYY-YYYY), array of strings (years)
  if (typeof preparedTemporal === 'string' && preparedTemporal.length === 9) {
    // YYYY-YYYY
    var _preparedTemporal$spl = preparedTemporal.split('-'),
        _preparedTemporal$spl2 = _slicedToArray(_preparedTemporal$spl, 2),
        start = _preparedTemporal$spl2[0],
        stop = _preparedTemporal$spl2[1];

    if (start > stop) {
      throw new Error('data.temporal not valid');
    }
    preparedTemporal = [];
    /*eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }]*/
    for (var i = start; i <= stop; i++) {
      preparedTemporal.push(i.toString());
    }
  } else if (!Array.isArray(preparedTemporal) && typeof preparedTemporal === 'string' && preparedTemporal.length !== 4) {
    throw new Error('data.temporal not valid');
  }
  return preparedTemporal;
};

var bubble = function bubble(container, data, title) {
  // set margins
  var top = title ? 50 : 20;
  var margin = { top: top, right: 100, bottom: 20, left: 30 };

  // prepare svg and g for drawing
  var svg = d3.select(container);
  var width = +svg.attr('width') - margin.left - margin.right;
  var height = +svg.attr('height') - margin.top - margin.bottom;

  // the group for the actual bubble chart
  var g = svg.append('g').attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');

  // create title and axis labels
  if (title) {
    svg.append('text').attr('x', svg.attr('width') / 2).attr('y', margin.top / 2).attr('text-anchor', 'middle').attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '14px').text(title);
  }
  if (data.x.label) {
    g.append('text').attr('x', width).attr('y', height - 5).attr('font-size', '11px').attr('fill', 'grey').attr('text-anchor', 'end').text(data.x.label);
  }
  if (data.y.label) {
    g.append('text').attr('x', 0).attr('y', 15).attr('font-size', '11px').attr('fill', 'grey').attr('text-anchor', 'end').attr('transform', 'rotate(-90)').text(data.y.label);
  }

  // prepare urls for json calls
  var temporal = getTemporalParmeter(data.temporal);
  var firstYear = Array.isArray(temporal) ? temporal[0] : temporal;
  var xUrl = 'https://ephtracking.cdc.gov/apigateway/api/v1/getCoreHolder/' + data.x.measureId + '/1/ALL/ALL/' + temporal + '/' + (data.x.isSmoothed || 0) + '/0';
  var yUrl = 'https://ephtracking.cdc.gov/apigateway/api/v1/getCoreHolder/' + data.y.measureId + '/1/ALL/ALL/' + temporal + '/' + (data.y.isSmoothed || 0) + '/0';

  // get data asynchronously
  var q = d3.queue();
  q.defer(d3.json, xUrl);
  q.defer(d3.json, yUrl);
  q.await(function (error, xResponse, yResponse) {
    if (error) {
      console.error(error);
      throw error;
    }

    var xData = xResponse && xResponse[xResponse.tableReturnType];
    var yData = yResponse && yResponse[yResponse.tableReturnType];

    if (!xData || !yData || xData.length === 0 || yData.length === 0) {
      g.append('text').attr('font-family', 'monospace').text('no data');
    } else {
      // scales
      var xScale = d3.scaleLinear().domain([d3.min(xData, function (d) {
        return parseFloat(d.dataValue);
      }), d3.max(xData, function (d) {
        return parseFloat(d.dataValue);
      })]).range([0, width]);

      var yScale = d3.scaleLinear().domain([d3.min(yData, function (d) {
        return parseFloat(d.dataValue);
      }), d3.max(yData, function (d) {
        return parseFloat(d.dataValue);
      })]).range([height, 0]);

      var bubbleScale = d3.scaleLinear().domain([d3.min(d3.values(_population2.default)), d3.max(d3.values(_population2.default))]).range([5, 30]);

      // fill regions
      var regions = ['Northeast', 'Midwest', 'South', 'West'];
      var fillColor = d3.scaleOrdinal().domain(regions).range(['#324D5C', '#46B29D', '#F0CA4D', '#DE5349']);
      var strokeColor = d3.scaleOrdinal().domain(regions).range(['#7EC2E8', '#2D7265', '#B09439', '#9E3B34']);

      // axis
      var xAxis = d3.axisBottom().scale(xScale);
      g.append('g').attr('class', 'axis').attr('transform', 'translate(0, ' + height + ')').call(xAxis);
      var yAxis = d3.axisLeft().scale(yScale);
      g.append('g').attr('class', 'axis').attr('transform', 'translate(0, 0)').call(yAxis);

      var tip = (0, _d3Tip2.default)().attr('class', 'd3-tip').html(function (d) {
        return '' + d.geo;
      });
      svg.call(tip);

      // generate data pairs
      var _data = Object.keys(_population2.default).map(function (state) {
        var entry = { population: _population2.default[state], geo: state, x: {}, y: {} };
        // substr: five year period
        xData.filter(function (e) {
          return e.geo === state;
        }).forEach(function (e) {
          return entry.x[e.year.substr(e.year.length - 4)] = e;
        });
        yData.filter(function (e) {
          return e.geo === state;
        }).forEach(function (e) {
          return entry.y[e.year.substr(e.year.length - 4)] = e;
        });
        return entry;
      });

      // create legend
      svg.append('g').attr('class', 'legendOrdinal').attr('transform', 'translate(' + (width + margin.left + 12) + ', ' + margin.top + ')');
      var legendOrdinal = _d3SvgLegend2.default.legendColor().title(firstYear).classPrefix('ephviz-').scale(fillColor)
      // highlight the mousover region
      .on('cellover', function (d) {
        regions.filter(function (r) {
          return r !== d;
        }).forEach(function (region) {
          d3.selectAll('.ephviz-' + region).style('opacity', 0.10);
        });
      }).on('cellout', function (d) {
        regions.forEach(function (region) {
          d3.selectAll('.ephviz-' + region).style('opacity', null);
        });
      });
      svg.select('.legendOrdinal').call(legendOrdinal);

      // draw circle
      var dot = g.selectAll('circle').data(_data).enter().append('circle').attr('cx', function (d) {
        if (d.x[firstYear] && parseFloat(d.x[firstYear].dataValue) && d.y[firstYear] && parseFloat(d.y[firstYear].dataValue)) {
          return xScale(parseFloat(d.x[firstYear].dataValue));
        }
        return width / 2;
      }).attr('cy', function (d) {
        if (d.x[firstYear] && parseFloat(d.x[firstYear].dataValue) && d.y[firstYear] && parseFloat(d.y[firstYear].dataValue)) {
          return yScale(parseFloat(d.y[firstYear].dataValue));
        }
        return height / 2;
      }).attr('class', function (d) {
        return 'ephviz-' + _regionsLookup2.default[d.geo];
      }) // for highlighting when hovering over legend
      .attr('r', function (d) {
        return bubbleScale(d.population);
      }).style('fill', function (d) {
        return fillColor(_regionsLookup2.default[d.geo]);
      }).style('stroke', function (d) {
        return strokeColor(_regionsLookup2.default[d.geo]);
      }).style('stroke-width', '1px').style('display', function (d) {
        if (d.x[firstYear] && parseFloat(d.x[firstYear].dataValue) && d.y[firstYear] && parseFloat(d.y[firstYear].dataValue)) {
          return null;
        }
        return 'none';
      }).on('mouseover', tip.show).on('mouseout', tip.hide);

      // animate dots
      var updateDots = function updateDots(year) {
        dot.transition().duration(750).attr('cx', function (d) {
          if (d.x[year] && parseFloat(d.x[year].dataValue) && d.y[year] && parseFloat(d.y[year].dataValue)) {
            return xScale(parseFloat(d.x[year].dataValue));
          }
          return width / 2;
        }).attr('cy', function (d) {
          if (d.x[year] && parseFloat(d.x[year].dataValue) && d.y[year] && parseFloat(d.y[year].dataValue)) {
            return yScale(parseFloat(d.y[year].dataValue));
          }
          return height / 2;
        }).style('display', function (d) {
          if (d.x[year] && parseFloat(d.x[year].dataValue) && d.y[year] && parseFloat(d.y[year].dataValue)) {
            return null;
          }
          return 'none';
        });

        d3.select('.ephviz-legendTitle').text(year);
      };
      var i = 1;
      var startAnimation = function startAnimation() {
        svg.selectAll('.replay').remove();
        var intervalId = setInterval(function () {
          updateDots(temporal[i]);
          i++;
          if (i === temporal.length) {
            clearInterval(intervalId);
            i = 1;
            // add replay link
            g.append('text').attr('class', 'replay').attr('x', width + 29).attr('y', 102).attr('text-anchor', 'middle').style('fill', 'darkblue').attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '12px').text('Replay').on('click', function () {
              updateDots(temporal[0]); // immediately run the first one
              startAnimation();
            });
          }
        }, 1500);
      };

      if (Array.isArray(temporal)) {
        startAnimation();
      }
    }
  });
};

exports.default = bubble;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ephtracking-viz/dist/visualizations/bubble.js
// module id = 1290
// module chunks = 0